<template>
  <div>
    <div v-if="idea" class="entire text-left">
      <p class='quote mb-0 text-left'>
        {{idea.content}}
      </p>
      <p class="text-right quotename mb-0">{{(idea.anonymous || !idea.author) ? 'xxxxx':namelist[idea.author]}}</p>
    </div>
    <div v-else class="entire">
      <p class='quote mb-0 text-left'>
        {{'引用したメッセージは削除されました。'}}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['idea', 'namelist']
}
</script>

<style scoped>
.quote {
  font-size: smaller;
}
.entire {
  margin-top: 7px;
  color: gray;
  padding-left: 5px;
  border-left: solid;
  border-color: rgb(109, 109, 109);
}
.quotename {
  font-size: small;
}
</style>